import { useCurrentLocation } from '@booking-portal/composables/use-current-location';
import { i18nLocaleStorage } from '@booking-portal/config/i18n-config';
import { getFavIcons } from '@booking-portal/utils/appearance-utils';
import { useHead } from '@unhead/vue';
import { computed, onMounted, watch } from 'vue';
import { useI18n } from 'vue-i18n';

export function useI18nLocale() {
  const { locale } = useI18n();
  const { routeLocationId } = useCurrentLocation();

  const faviconLinks = computed(() => {
    return getFavIcons(routeLocationId.value);
  });

  useHead({
    link: faviconLinks,
    htmlAttrs: {
      lang: locale,
    },
  });

  onMounted(() => {
    watch(locale, (value) => {
      if (i18nLocaleStorage.fallbackLanguage === value) {
        i18nLocaleStorage.clear();
      } else {
        i18nLocaleStorage.set(value);
      }
      document.documentElement.setAttribute('lang', value);
    });
  });
}
